<template>
  <el-dialog
    :visible.sync="edit.visible"
    :title="edit.isEdit ? '编辑' : '新增'"
    width="700px"
    :close-on-click-modal="false"
  >
    <el-form
      :key="edit.data.type"
      ref="form"
      :model="edit.data"
      :rules="rules"
      label-width="10em"
      size="small"
    >
      <div
        :style="{
          marginBottom: '10px',
          fontSize: '16px',
          fontWeight: 'bold'
        }"
      >
        基础信息
      </div>
      <el-form-item label="图标" prop="icon">
        <el-upload
          action="/api/uploads"
          accept="image/*"
          :show-file-list="false"
          style="
            position: relative;
            width: 80px;
            height: 80px;
            border: 1px dashed #aaa;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          v-bind="iconUploadProps"
          v-loading="iconUploadProps.uploading.value"
        >
          <img
            v-if="edit.data.icon"
            :src="edit.data.icon"
            style="width: 80px"
          />
          <div
            style="
              width: 80px;
              height: 80px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              line-height: 1.8;
            "
            v-else
          >
            <i class="el-icon-upload" style="font-size: 20px"></i>
            点击上传
          </div>

          <el-button
            type="primary"
            size="mini"
            style="
              position: absolute;
              right: 0;
              bottom: 0;
              transform: translateX(calc(100% + 10px));
            "
            >上传图标</el-button
          >
        </el-upload>
        <icon-select
          style="position: absolute; left: 90px; top: 0"
          @change="url => (edit.data.icon = url)"
        />
      </el-form-item>

      <el-form-item label="名称" prop="appName">
        <el-input v-model="edit.data.appName" />
      </el-form-item>

      <el-form-item label="URL" prop="url">
        <el-input v-model="edit.data.url" />
      </el-form-item>

      <el-form-item label="标签" prop="labels">
        <el-select
          v-model="edit.data.labels"
          multiple
          filterable
          allow-create
          default-first-option
          style="width: 60%"
        >
          <el-option
            v-for="(label, index) in labels"
            :key="index"
            :label="label"
            :value="label"
          />
        </el-select>
      </el-form-item>

      <div
        :style="{
          marginTop: '30px',
          marginBottom: '10px',
          fontSize: '16px',
          fontWeight: 'bold'
        }"
      >
        操作设置
      </div>
      <el-form-item label="操作区域" props="operation">
        <el-checkbox-group v-model="edit.data.operation">
          <el-checkbox label="forward">前进</el-checkbox>
          <el-checkbox label="back">后退</el-checkbox>
          <el-checkbox label="home">主页</el-checkbox>
          <el-checkbox label="refresh">刷新</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-form-item label="显示横竖屏开关" prop="showOrientationSwitch">
            <el-switch v-model="edit.data.showOrientationSwitch" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="默认横屏" prop="orientation">
            <el-switch
              v-model="edit.data.orientation"
              active-value="landscape"
              inactive-value="portrait"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="显示底部翻页" prop="showPageTurner">
            <el-switch v-model="edit.data.showPageTurner" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="打开新窗口" prop="openNewWindow">
            <el-switch v-model="edit.data.openNewWindow" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
            label="同步用户登录"
            prop="cookies"
            style="margin-bottom: 0"
          >
            <el-switch v-model="edit.data.cookies" />
          </el-form-item>
        </el-col>
      </el-row>

      <hr style="" />

      <el-row>
        <el-col :span="12">
          <el-form-item label="显示缩放开关" prop="showScaleSwitch">
            <el-switch v-model="edit.data.showScaleSwitch" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="字体缩放" prop="scale">
            <el-input-number
              v-model="edit.data.scale"
              controls-position="right"
            />
            <span style="margin-bottom: 20px; margin-left: 4px">%</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="对比度增强" prop="contrast">
            <el-input-number
              v-model="edit.data.contrast"
              :min="0"
              controls-position="right"
            />
            %
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="DPI" prop="dpi">
            <el-input-number
              v-model="edit.data.dpi"
              :min="0"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="页面比例">
            <div style="display: flex; align-items: center; gap: 5px">
              <el-form-item prop="ratio_width">
                <el-input-number
                  v-model="edit.data.ratio_width"
                  :min="0"
                  :controls="false"
                  style="width: 60px"
                />
              </el-form-item>
              <span style="margin-bottom: 20px">/</span>
              <el-form-item prop="ratio_height">
                <el-input-number
                  v-model="edit.data.ratio_height"
                  :min="0"
                  :controls="false"
                  style="width: 60px"
                />
              </el-form-item>
              <span style="margin-bottom: 20px">(宽/高)</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <div
        :style="{
          marginTop: '30px',
          marginBottom: '10px',
          fontSize: '16px',
          fontWeight: 'bold'
        }"
      >
        高级
      </div>
      <el-form-item label="初始化脚本">
        <el-input
          v-model="edit.data.initScript"
          type="textarea"
          :rows="10"
          class="script-area"
        />
      </el-form-item>
      <el-form-item label="UA">
        <el-input v-model="edit.data.special_ua" />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="edit.visible = false"> 取消 </el-button>
      <el-button
        type="primary"
        :disabled="edit.loading || edit.saving"
        @click="onSubmit"
      >
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { GET } from '@/admin-shared-modules/utils/ajax'
import { ref, watch } from 'vue'
import { useUpload } from '../useUpload'
import IconSelect from './icon-select.vue'
import { store } from './store'

const edit = store.edit

const form = ref()
const rules = {
  icon: { required: true, message: '请填写' },
  appName: { required: true, message: '请填写' },
  url: { required: true, message: '请填写' }
}

const iconUploadProps = useUpload({
  onUpload(url) {
    store.edit.data.icon = url
  }
})

async function onSubmit() {
  await form.value.validate()
  store.edit.onEditSubmit()
}

const labels = ref([])
async function fetchLabels() {
  try {
    const res = await GET('template_app/labels', {})
    labels.value = res.data
  } catch (error) {}
}

watch(
  () => edit.visible,
  () => {
    if (edit.visible) {
      fetchLabels()
    }
  }
)
</script>

<style scoped lang="scss">
@import '~@/admin-shared-modules/theme/var';

.script-area .el-textarea__inner {
  padding: 1em;
  font-family: monospace sans-serif;
  font-size: 13px;
  line-height: 2.4;
}
</style>
